import { render, staticRenderFns } from "./ProgrammeFeed.vue?vue&type=template&id=22b0be29&"
import script from "./ProgrammeFeed.vue?vue&type=script&lang=js&"
export * from "./ProgrammeFeed.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports